import React, { Children, Component } from 'react'
import PropTypes from 'prop-types'
import { FormSection, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import classnames from 'classnames'
import { getDefaultValues, translate, REDUX_FORM_NAME } from 'ra-core'

import { FormInput, Toolbar, CardContentInner, GET_ONE } from 'react-admin'
import dataProvider from '../../utils/dataProvider'
import { DatasheetForm } from '../Generic'
import { WithPermissions } from 'react-admin'

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

const styles = {
    inputs : {
        width: '100%'
    }
}

const sanitizeRestProps = ({
    anyTouched,
    array,
    asyncBlurFields,
    asyncValidate,
    asyncValidating,
    autofill,
    blur,
    change,
    clearAsyncError,
    clearFields,
    clearSubmit,
    clearSubmitErrors,
    destroy,
    dirty,
    dispatch,
    form,
    handleSubmit,
    initialize,
    initialized,
    initialValues,
    pristine,
    pure,
    redirect,
    reset,
    resetSection,
    save,
    submit,
    submitFailed,
    submitSucceeded,
    submitting,
    touch,
    translate,
    triggerSubmit,
    undoable,
    untouch,
    valid,
    validate,
    ...props
}) => props

export class SimpleForm extends Component {

    state = {
        withSchemaForm : false,
        schema : null
    }

    handleSubmitWithRedirect = (redirect = this.props.redirect) =>
        this.props.handleSubmit(values => this.props.save(values, redirect))

    componentDidMount(){
        const { record : { datasheet_type } } = this.props
        if(datasheet_type){
            dataProvider(GET_ONE, "esquemas-datos-tecnicos", {id : datasheet_type})
            .then(response => {
                this.setState({
                    withSchemaForm: true,
                    schema: response.data.schema,
                })

            })
            .catch(error => {
                console.log(error)
            })
        }
    }

    render() {
        const {
            basePath,
            children,
            className,
            invalid,
            pristine,
            record,
            redirect,
            resource,
            saving,
            submitOnEnter,
            toolbar,
            undoable,
            version,
            classes,
            ...rest
        } = this.props

        const { withSchemaForm, schema } = this.state

        return (
            <form
                className={classnames('simple-form', className)}
                {...sanitizeRestProps(rest)}
            >
                <CardContentInner key={version}>
                    <Grid container spacing={24}>
                    {Children.map(children, input => (
                        <Grid item xs={12} md={4} >
                            <FormInput
                                basePath={basePath}
                                input={input}
                                record={record}
                                resource={resource}
                                className={classes.inputs}
                            />
                        </Grid>
                    ))}
                    </Grid>
                    {withSchemaForm &&
                    <Grid container spacing={24}>
                        <WithPermissions>
                        {({ permissions }) => {
                            if(permissions === null) return null
                            return  (
                                <FormSection name="datasheet">
                                    <DatasheetForm
                                        schema={schema}
                                        permissions={permissions}
                                        initialValues={this.props.initialValues}
                                    />
                                </FormSection>
                            )
                        }}
                        </WithPermissions>
                    </Grid>}
                </CardContentInner>
                {toolbar &&
                    React.cloneElement(toolbar, {
                        basePath,
                        handleSubmitWithRedirect: this.handleSubmitWithRedirect,
                        handleSubmit: this.props.handleSubmit,
                        invalid,
                        pristine,
                        record,
                        redirect,
                        resource,
                        saving,
                        submitOnEnter,
                        undoable,
                    })}
            </form>
        )
    }
}

SimpleForm.propTypes = {
    basePath: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    handleSubmit: PropTypes.func, // passed by redux-form
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    record: PropTypes.object,
    resource: PropTypes.string,
    redirect: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.func,
    ]),
    save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
    saving: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    submitOnEnter: PropTypes.bool,
    toolbar: PropTypes.element,
    undoable: PropTypes.bool,
    validate: PropTypes.func,
    version: PropTypes.number,
}

SimpleForm.defaultProps = {
    submitOnEnter: true,
    toolbar: <Toolbar />,
}

const enhance = compose(
    connect((state, props) => ({
        form: props.form || REDUX_FORM_NAME,
        initialValues: getDefaultValues(state, props),
        saving: props.saving || state.admin.saving,
    })),
    translate, // Must be before reduxForm so that it can be used in validation
    reduxForm({
        destroyOnUnmount: false,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
    }),
    withStyles(styles)
)

export default enhance(SimpleForm)
